export const specialCharRegexGlobal = /[@#$£%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;
export const numbersOnlyRegex = /^\d+$/;

export default { specialCharRegexGlobal, numbersOnlyRegex };
